/*@flow*/
import * as I from 'immutable';
import UIDGenerator from './util/UIDGenerator';

const initState = {
  value: {},
  defaultValue: null,
  type: {},
  errors: [],
  uidGenerator: new UIDGenerator('0'),
  onChange: null,
};

export default I.Record(initState);
